module.exports = __webpack_public_path__ + "img/964.a9a8fd2d.png";